// useImageUpload.js
// Custom hook for handling image file uploads
// Manages upload state and provides function to upload images with authentication

import { useState, useCallback } from 'react';
import { uploadImage } from '../services/uploadApi';

export function useImageUpload() {
  const [uploading, setUploading] = useState(false);  // Tracks upload in progress
  const [error, setError] = useState(null);            // Stores upload error messages

  // Uploads an image file to the server
  // Requires authentication token, returns image URL on success, null on failure
  const handleImageUpload = useCallback(async (file, idToken) => {
    setUploading(true);
    setError(null);
    try {
      const url = await uploadImage(file, idToken);
      return url;
    } catch (err) {
      setError(err.message || 'Image upload failed');
      return null;
    } finally {
      setUploading(false);
    }
  }, []);

  return { handleImageUpload, uploading, error };
}

export default useImageUpload;